import { QuestionPlanLongStayParams as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/long-stay-params";

import { usePlanLongStayParams } from "./hooks";

export const QuestionPlanLongStayParams = () => {
	const { longStayParams, onSetLongStayParams } = usePlanLongStayParams();

	return <Question longStayParams={longStayParams} onSetLongStayParams={onSetLongStayParams} />;
};

QuestionPlanLongStayParams.displayName = "QuestionPlanLongStayParams";
